import { useState, useEffect } from "react";
import BarraImpersonacion from "./BarraImpersonacion";
import ComercioExterior from "./ComercioExterior";
import { ModalGenerarOC } from "./ComprasUtils";
import { autenticarSupabase, autenticarSupabaseDesdeSesion, puedeVer, syncUsuariosDesdeSupabase, syncPermisosDesdeSupabase } from "./GestorUsuarios";
import { supabase } from "./supabase";
import NoConformidades from "./NoConformidades";
import Aria from "./Aria";
import FeedbackWidget from "./FeedbackWidget";
import OrdenTrabajo from "./OrdenTrabajo";
import Documentos from "./Documentos";
import Instructivos from "./Instructivos";
import CumplimientoNormas from "./CumplimientoNormas";
import Auditorias from "./Auditorias";
import Capacitaciones from "./Capacitaciones";
import Proveedores from "./Proveedores";
import Clientes from "./Clientes";
import Compras from "./Compras";
import HigieneSeguridad from "./HigieneSeguridad";
import ConsultorHS from "./ConsultorHS";
import MapaProcesos from "./MapaProcesos";
import CentrosCosto from "./CentrosCosto";
import PlanCuentas from "./PlanCuentas";
import AsientosContables from "./AsientosContables";
import CuentasCobrarPagar from "./CuentasCobrarPagar";
import MovimientosCaja from "./MovimientosCaja";
import Finanzas from "./Finanzas";
import BalanceSimplificado from "./BalanceSimplificado";
import MotorCosteo from "./MotorCosteo";
import PrePrensa from "./PrePrensa";
import Produccion from "./Produccion";
import Ventas from "./Ventas";
import Cotizacion from "./Cotizacion";
import OficinaTecnica from "./OficinaTecnica";
import FamiliasLineas from "./FamiliasLineas";
import Maquinas from "./Maquinas";
import RecursosHumanos from "./RecursosHumanos";
import Comunicados from "./Comunicados";
import Onboarding from "./Onboarding";
import ModuloBase from "./ModuloBase";
import FMEA from "./FMEA";
import PlanControl from "./PlanControl";
import ControlCalidadPiso from "./ControlCalidadPiso";
import AccionesCorrectivas from "./AccionesCorrectivas";
import DashboardCA from "./DashboardCA";
import FSCArqueo from "./FSCArqueo";
import ImportadorCSV from "./ImportadorCSV";
import AdminUsuarios from "./AdminUsuarios";
import SuperAdmin from "./SuperAdmin";
import TPMMantenimiento from "./TPMMantenimiento";
import { verificarVencimientos, verificarAlertasOperaciones, verificarAlertasReposicion } from "./NotificadorALQOS";
import Ciberseguridad from "./Ciberseguridad";
import { sincronizarTodo } from './syncSupabase';
import Sustentabilidad from "./Sustentabilidad";
import Capabilidad from "./Capabilidad";
import AnalisisCausa from "./AnalisisCausa";
import ProgramaAuditorias from "./ProgramaAuditorias";
import AssuredQuality from "./AssuredQuality";
import IngresoMateriales from "./IngresoMateriales";
import StockMateriales from "./StockMateriales";
import HuellaCarbono from "./HuellaCarbono";
import HACCP from "./HACCP";
import POEs from "./POEs";
import HomeKPIs from "./HomeKPIs";
import Trazabilidad from "./Trazabilidad.jsx";
import Despacho from "./Despacho";
import CostosNoCalidad from "./CostosNoCalidad";
import EscritorioCalidad from "./EscritorioCalidad";
import EspecificacionesTecnicas from "./EspecificacionesTecnicas";
import DisenoDesarrollo from "./DisenoDesarrollo";
import PortalEmpleado from "./PortalEmpleado";
import LegalMatrixEngine from "./LegalMatrixEngine";
import AlqosNews, { AlqosNewsPill } from "./AlqosNews";
import AuditoriaTrazabilidad from "./AuditoriaTrazabilidad";
import EticaRSE from "./EticaRSE"
const Q = {
  azul:"#1C3FAA", azulVivo:"#2A7FFF", azulMedio:"#6B6FD6",
  grisClaro:"#E8E9F6", grisPalido:"#F4F6FB", grisOscuro:"#2B2F36",
  grisPlata:"#8E93A1", blanco:"#FFFFFF", navOscuro:"#0d1f6e",
  cardOscuro:"#0a1a5c", fondoOscuro:"#08133f", panelOscuro:"#0a1740",
  panelLogin:"#0F1C2E",
};
const modulos = [
  { id:1,  nombre:"Órdenes de Trabajo",       icono:"📋" },
  { id:2,  nombre:"No Conformidades",          icono:"⚠️" },
  { id:3,  nombre:"Documentos",                icono:"📁" },
  { id:4,  nombre:"Familias y Líneas",         icono:"🏭" },
  { id:5,  nombre:"FMEA",                      icono:"🔍" },
  { id:6,  nombre:"Plan de Control",           icono:"✅" },
  { id:7,  nombre:"Capabilidad y MSA",         icono:"📊" },
  { id:8,  nombre:"Dashboard CA",              icono:"🏅" },
  { id:9,  nombre:"Proveedores",               icono:"🤝" },
  { id:10, nombre:"Cotización",                icono:"💰" },
  { id:11, nombre:"Capacitaciones",            icono:"🎓" },
  { id:12, nombre:"Auditorías",                icono:"🔎" },
  { id:13, nombre:"Compras",                   icono:"🛒" },
  { id:14, nombre:"Diseño y Desarrollo",       icono:"✏️" },
  { id:15, nombre:"Producción",                icono:"🏗️" },
  { id:16, nombre:"Recursos Humanos",          icono:"👥" },
  { id:17, nombre:"Ventas",                    icono:"📈" },
  { id:18, nombre:"Pre Prensa",                icono:"🖨️" },
  { id:19, nombre:"Oficina Técnica",           icono:"📐" },
  { id:20, nombre:"Clientes",                  icono:"🤝" },
  { id:21, nombre:"Especificaciones Técnicas", icono:"📌" },
  { id:22, nombre:"Higiene y Seguridad",       icono:"🦺" },
  { id:23, nombre:"TPM Mantenimiento",         icono:"🔧" },
  { id:24, nombre:"Comercio Exterior",         icono:"🌐" },
  { id:25, nombre:"ARIA — IA",                 icono:"🤖" },
  { id:26, nombre:"Usuarios",                  icono:"👥" },
  { id:27, nombre:"Acciones Correctivas",      icono:"🔁" },
  { id:28, nombre:"FSC Arqueo",                icono:"🌿" },
  { id:29, nombre:"Importar CSV",              icono:"📥" },
  { id:30, nombre:"Ciberseguridad",            icono:"🔐" },
  { id:31, nombre:"Sustentabilidad y MA",      icono:"🌿" },
  { id:32, nombre:"Análisis de Causa",         icono:"🔬" },
  { id:33, nombre:"Programa Auditorías",       icono:"📅" },
  { id:34, nombre:"Assured Quality",           icono:"🏆" },
  { id:35, nombre:"Ingreso de Materiales",     icono:"📦" },
  { id:36, nombre:"Huella de Carbono",         icono:"🌱" },
  { id:37, nombre:"HACCP",                      icono:"🧫" },
  { id:38, nombre:"POEs",                       icono:"📄" },
  { id:39, nombre:"Stock Materiales",          icono:"📦" },
  { id:40, nombre:"Trazabilidad",             icono:"🔗" },
  { id:41, nombre:"Despacho",                  icono:"📦" },
  { id:43, nombre:"Costos de No Calidad",       icono:"💸" },
  { id:44, nombre:"Instructivos ALQOS™",        icono:"📖" },
  { id:45, nombre:"Cumplimiento de Normas",      icono:"📋" },
  { id:46, nombre:"Comunicados Internos",       icono:"📢" },
  { id:47, nombre:"Onboarding",                 icono:"🚀" },
  { id:48, nombre:"Escritorio Calidad",         icono:"🗂️" },
  { id:49, nombre:"ALQOS Asesor",               icono:"🔍" },
  { id:50, nombre:"Mapa de Procesos ALQOS™",    icono:"🗺️" },
  { id:51, nombre:"Centros de Costo",            icono:"⚙️" },
  { id:52, nombre:"Motor de Costeo",              icono:"🧮" },
  { id:53, nombre:"LegalMatrix Engine",           icono:"⚖️" },
  { id:54, nombre:"Plan de Cuentas",              icono:"📒" },
  { id:55, nombre:"Asientos Contables",           icono:"📑" },
  { id:56, nombre:"Cuentas por Cobrar/Pagar",     icono:"💳" },
  { id:57, nombre:"Movimientos de Caja",          icono:"🏦" },
  { id:58, nombre:"Finanzas",                     icono:"💰" },
  { id:59, nombre:"Balance",                      icono:"📊" },
  { id:60, nombre:"Máquinas",                     icono:"⚙️" },
  { id:61, nombre:"Auditoría y Trazabilidad",     icono:"🕵️" },
  { id:62, nombre:"Control de Calidad de Piso",   icono:"📋" },
  { id:63, nombre:"Ética y RSE", icono:"🕊️" },
];
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&family=Inter:wght@300;400;500;600;700;800&display=swap');
  @keyframes rotateHex  { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }
  @keyframes fadeUp     { from{opacity:0;transform:translateY(12px)} to{opacity:1;transform:translateY(0)} }
  @keyframes circPulse  { 0%,100%{opacity:.04} 50%{opacity:.10} }
  * { box-sizing: border-box; }
  body { font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif !important; }
`;
// ─── LOGO — A ISOTIPO ─────────────────────────────────────────
function AlqosLogo({ size = 48, variant = "color" }) {
  const isWhite = variant === "white";
  return (
    <div style={{ position:"relative", width:size, height:size, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center" }}>
      <svg width={size} height={size} viewBox="0 0 100 100" fill="none">
        {/* Círculo exterior punteado rotando */}
        <circle cx="50" cy="50" r="47" fill="none"
          stroke={isWhite?"rgba(255,255,255,0.3)":"url(#ringGrad)"}
          strokeWidth="1.5" strokeDasharray="8 5"
          style={{ animation:"rotateHex 16s linear infinite", transformOrigin:"50px 50px" }}/>
        {/* Fondo circular con gradiente */}
        <circle cx="50" cy="50" r="42" fill={isWhite?"url(#bgWhite)":"url(#bgColor)"}/>
        {/* Borde interior sutil */}
        <circle cx="50" cy="50" r="42" fill="none"
          stroke={isWhite?"rgba(255,255,255,0.2)":"rgba(255,255,255,0.15)"}
          strokeWidth="0.8"/>
        {/* La A con Rajdhani */}
        <text x="50" y="70" textAnchor="middle"
          fontFamily="Montserrat, sans-serif"
          fontWeight="700"
          fontSize="60"
          fill="white"
          style={{ filter:"drop-shadow(0 2px 8px rgba(0,0,0,0.4))" }}>
          A
        </text>
        {/* Línea decorativa inferior */}
        <line x1="30" y1="84" x2="70" y2="84"
          stroke={isWhite?"rgba(255,255,255,0.35)":"rgba(255,255,255,0.3)"}
          strokeWidth="1.2" strokeLinecap="round"/>
        <defs>
          <linearGradient id="bgColor" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2A7FFF"/>
            <stop offset="100%" stopColor="#1C3FAA"/>
          </linearGradient>
          <linearGradient id="bgWhite" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="rgba(255,255,255,0.22)"/>
            <stop offset="100%" stopColor="rgba(42,127,255,0.18)"/>
          </linearGradient>
          <linearGradient id="ringGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#2A7FFF"/>
            <stop offset="100%" stopColor="#6B6FD6"/>
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
// ─── LOGIN ────────────────────────────────────────────────────
const loginCardCss = `
  .login-card, .login-card *{ box-sizing:border-box; }
  .login-card{ position:relative; width:340px; max-width:90vw; background:#fff; border-radius:10px; padding:36px 32px 30px; box-shadow:0 20px 60px rgba(0,0,0,.5); text-align:center; font-family:'Inter',sans-serif; }
  .login-logo{ font-size:26px; font-weight:800; color:#0B1D57; letter-spacing:1px; margin-bottom:2px; }
  .login-logo span{ color:#2A6BFF; }
  .login-tagline{ font-size:11px; color:#8a8fa3; margin-bottom:22px; letter-spacing:.5px; }
  .login-field{ text-align:left; margin-bottom:14px; }
  .login-field label{ display:block; font-size:12px; color:#161A2B; margin-bottom:5px; font-weight:600; }
  .login-field input{ width:100%; padding:10px 12px; border:1px solid #d7d9e6; border-radius:6px; font-size:14px; background:#EEF1FB; color:#161A2B; outline:none; font-family:inherit; transition:border-color .2s; }
  .login-field input:focus{ border-color:#2A6BFF; }
  .login-remember-row{ display:flex; align-items:center; justify-content:space-between; margin:2px 0 16px; font-size:11.5px; }
  .login-remember-check{ display:flex; align-items:center; gap:6px; color:#5A6480; cursor:pointer; user-select:none; }
  .login-remember-check input{ width:13px; height:13px; accent-color:#2A6BFF; cursor:pointer; }
  .login-forgot-link{ color:#2A6BFF; font-weight:600; cursor:pointer; }
  .login-forgot-link:hover{ text-decoration:underline; }
  .login-btn{ width:100%; margin-top:8px; padding:11px; border:none; border-radius:6px; background:linear-gradient(135deg,#0B1D57,#2A6BFF 130%); color:#fff; font-weight:700; font-size:14px; letter-spacing:.4px; cursor:pointer; transition:filter .2s, transform .1s; font-family:inherit; }
  .login-btn:hover{ filter:brightness(1.08); }
  .login-btn:active{ transform:scale(.98); }
  .login-footer{ margin-top:16px; font-size:10.5px; color:#a5a9bd; line-height:1.6; }
`;
function Login({ onLogin }) {
  const [email,      setEmail]      = useState("");
  const [password,   setPassword]   = useState("");
  const [error,      setError]      = useState("");
  const [recordarme, setRecordarme] = useState(false);
  const [showPass,   setShowPass]   = useState(false);
  useEffect(() => {
    const saved = localStorage.getItem("alqos_remember");
    if (saved) { try { const d=JSON.parse(saved); setEmail(d.email||""); setRecordarme(true); } catch {} }
  }, []);
  const handleLogin = async () => {
    setError("");
    const resultado = await autenticarSupabase(email, password);
    if (resultado.usuario) {
      if (recordarme) localStorage.setItem("alqos_remember", JSON.stringify({ email }));
      else localStorage.removeItem("alqos_remember");
      onLogin(resultado.usuario);
    } else {
      setError(resultado.error || "Usuario o contraseña incorrectos");
    }
  };
  return (
    <div className="login-card">
      <style>{loginCardCss}</style>
      <div className="login-logo">ALQ<span>OS</span></div>
      <div className="login-tagline">SISTEMA DE GESTIÓN INTEGRAL</div>
      <FormLogin email={email} setEmail={setEmail} password={password} setPassword={setPassword} showPass={showPass} setShowPass={setShowPass} recordarme={recordarme} setRecordarme={setRecordarme} error={error} onLogin={handleLogin}/>
    </div>
  );
}
// ─── FORM LOGIN ───────────────────────────────────────────────
function FormLogin({ email, setEmail, password, setPassword, showPass, setShowPass, recordarme, setRecordarme, error, onLogin }) {
  return (
    <div>
      <div className="login-field">
        <label>Usuario</label>
        <input type="email" value={email} onChange={e=>setEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&onLogin()} placeholder="usuario@empresa.com"/>
      </div>
      <div className="login-field">
        <label>Contraseña</label>
        <div style={{ position:"relative" }}>
          <input type={showPass?"text":"password"} value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&onLogin()} placeholder="••••••••" style={{ paddingRight:"38px" }}/>
          <button type="button" onClick={()=>setShowPass(s=>!s)} style={{ position:"absolute", right:"10px", top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", padding:"2px", color:"#8a8fa3", display:"flex", alignItems:"center" }}>
            {showPass
              ? <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
              : <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            }
          </button>
        </div>
      </div>
      <div className="login-remember-row">
        <label className="login-remember-check">
          <input type="checkbox" checked={recordarme} onChange={e=>setRecordarme(e.target.checked)}/>
          Recordarme
        </label>
        <span className="login-forgot-link">¿Olvidaste tu contraseña?</span>
      </div>
      {error && (
        <div style={{ display:"flex", alignItems:"center", gap:"8px", background:"#FEF2F2", border:"1px solid #FECACA", borderRadius:"9px", padding:"10px 14px", marginBottom:"14px", textAlign:"left" }}>
          <svg width="15" height="15" fill="none" stroke="#DC2626" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          <p style={{ color:"#DC2626", fontSize:"13px", margin:0, fontWeight:"500" }}>{error}</p>
        </div>
      )}
      <button type="button" className="login-btn" onClick={onLogin}>Iniciar sesión</button>
      <div className="login-footer">ALQOS™ · Todos los derechos reservados<br/>Solo personal autorizado</div>
    </div>
  );
}
// ─── INTRO LÁMPARA ────────────────────────────────────────────
const lamparaCss = `
  .lampara-stage{ position:fixed; inset:0; height:100vh; width:100%; overflow:hidden; display:flex; align-items:center; justify-content:center;
    background:radial-gradient(ellipse at 50% 0%, #12151d 0%, #05060a 70%); transition:background 1.2s ease; }
  .lampara-stage.on{ background:radial-gradient(ellipse at 50% 0%, #14275f 0%, #05060a 75%); }
  .lampara-wrap{ position:absolute; top:0; left:50%; transform:translateX(-50%); display:flex; flex-direction:column; align-items:center; z-index:5; }
  .lampara-cable{ width:2px; height:90px; background:#444; }
  .lampara-shade{ width:130px; height:70px; border-radius:0 0 70px 70px / 0 0 90px 90px; background:linear-gradient(180deg,#dfe1ea,#c7cadb); box-shadow:0 6px 18px rgba(0,0,0,.5); position:relative; }
  .lampara-shade::after{ content:""; position:absolute; left:50%; bottom:-10px; transform:translateX(-50%); width:16px; height:14px; background:#b9bccc; border-radius:2px; }
  .lampara-bulb{ position:absolute; top:65px; left:50%; transform:translateX(-50%); width:14px; height:14px; border-radius:50%; background:#eaf1ff; opacity:0; box-shadow:0 0 0px rgba(42,107,255,0); transition:opacity .3s ease, box-shadow .3s ease; }
  .lampara-stage.on .lampara-bulb{ opacity:1; box-shadow:0 0 30px 14px rgba(42,107,255,.85), 0 0 90px 60px rgba(42,107,255,.30); }
  .lampara-cone{ position:absolute; top:70px; left:50%; transform:translateX(-50%); width:0; height:0; border-left:230px solid transparent; border-right:230px solid transparent; border-top:520px solid rgba(42,107,255,0); transition:border-top-color 1s ease; pointer-events:none; }
  .lampara-stage.on .lampara-cone{ border-top-color:rgba(42,107,255,.12); }
  .lampara-chain{ position:absolute; top:88px; left:50%; transform:translateX(-8px); width:1px; height:60px; background:#666; cursor:pointer; z-index:6; }
  .lampara-knob{ position:absolute; bottom:-8px; left:50%; transform:translateX(-50%); width:10px; height:10px; border-radius:50%; background:#888; box-shadow:0 0 4px rgba(0,0,0,.6); transition:background .4s ease, box-shadow .4s ease; }
  .lampara-stage.on .lampara-knob{ background:#2A6BFF; box-shadow:0 0 10px rgba(42,107,255,.8); }
  .lampara-hint{ position:absolute; top:160px; left:50%; transform:translateX(-50%); color:#8a8fa3; font-size:12px; letter-spacing:.5px; white-space:nowrap; animation:lamparaPulse 1.8s ease-in-out infinite; z-index:6; font-family:Inter,sans-serif; }
  .lampara-stage.on .lampara-hint{ display:none; }
  @keyframes lamparaPulse{ 0%,100%{opacity:.4;} 50%{opacity:1;} }
  @keyframes lamparaTug{ 0%{transform:translateX(-8px) translateY(0);} 30%{transform:translateX(-8px) translateY(18px);} 100%{transform:translateX(-8px) translateY(0);} }
  .lampara-chain.tugging{ animation:lamparaTug .4s ease; }
  .lampara-login-overlay{ position:fixed; inset:0; z-index:20; display:flex; align-items:center; justify-content:center; opacity:0; transform:scale(.94); transition:opacity .7s ease, transform .7s cubic-bezier(.2,.9,.3,1.2); pointer-events:none; }
  .lampara-login-overlay.on{ opacity:1; transform:scale(1); pointer-events:auto; }
`;
function IntroLampara({ onLogin }) {
  const [on, setOn] = useState(false);
  const [tugging, setTugging] = useState(false);
  const tirar = () => {
    if (on) return;
    setTugging(true);
    setOn(true);
    setTimeout(() => setTugging(false), 400);
  };
  return (
    <div className={`lampara-stage${on ? " on" : ""}`}>
      <style>{lamparaCss}</style>
      <div className="lampara-wrap">
        <div className="lampara-cable"/>
        <div className="lampara-shade">
          <div className="lampara-bulb"/>
        </div>
        <div className={`lampara-chain${tugging ? " tugging" : ""}`} onClick={tirar}>
          <div className="lampara-knob"/>
        </div>
      </div>
      <div className="lampara-cone"/>
      <div className="lampara-hint">tirá de la cadena para encender</div>
      <div className={`lampara-login-overlay${on ? " on" : ""}`}>
        <Login onLogin={onLogin}/>
      </div>
    </div>
  );
}
// ─── MENÚ ─────────────────────────────────────────────────────
function Menu({ usuario, onLogout, oscuro, toggleOscuro, onModulo, online, syncMsg }) {
  const navBg      = oscuro ? Q.navOscuro   : Q.azul;
  const cardBg     = oscuro ? Q.cardOscuro  : Q.blanco;
  const texto      = oscuro ? "#EDF2FA"     : Q.grisOscuro;
  const cardBorder = oscuro ? "#1e3a8a"     : "#E8E9F6";
  const bgPage     = oscuro ? Q.fondoOscuro : Q.grisPalido;
  const esAdmin    = usuario?.rol === "Administrador";
  const getModulo = (id) => ({
    1:"ot",2:"nc",3:"docs",4:"familias",5:"fmea",6:"plancontrol",7:"capabilidad",
    8:"dashboardca",9:"proveedores",10:"cotizacion",11:"caps",12:"auditorias",
    13:"compras",14:"disenoydesarrollo",15:"produccion",16:"rrhh",17:"ventas",18:"preprensa",
    19:"oficina_tecnica",20:"clientes",21:"espectecnicas",22:"hs",23:"tpm",
    24:"comercioexterior",25:"aria",26:"adminusuarios",27:"accionescorrectivas",44:"instructivos",45:"cumplimiento",46:"comunicados",47:"onboarding",48:"escritorioCalidad",49:"consultorHS",50:"mapaProcesos",51:"centrosCosto",52:"motorCosteo",53:"legalmatrix",54:"plancuentas",55:"asientoscontables",56:"cxccxp",57:"movimientoscaja",58:"finanzas",59:"balancesimplificado",60:"maquinas",
    28:"fscarqueo",29:"importarcsv",30:"ciberseguridad",31:"sustentabilidad",
    32:"analisiscausa",33:"programaauditorias",34:"assuredquality",
    35:"ingresomateriales",36:"huellacarb",37:"haccp",38:"poes",39:"stock",40:"trazabilidad",41:"despacho",42:"disenoydesarrollo",43:"costosnocal",
    61:"auditoriatrazabilidad",62:"controlpiso",63:"eticarse",
  })[id] || null;
  const colorCat = {
    "Calidad y Operaciones":  "#2A7FFF",
    "Recepción y Materiales": "#22c55e",
    "Procesos Productivos":   "#7B5BF2",
    "Gestión y Soporte":      "#f59e0b",
    "Seguridad e Integridad": "#e63946",
    "Sustentabilidad":        "#22c55e",
    "Inteligencia":           "#2A7FFF",
    "Administración":         "#8E93A1",
    "Finanzas":               "#1C3FAA",
  };
  const categorias = [
    { label:"Calidad y Operaciones",  ids:[1,2,3,4,5,6,7,8,27,28,29,32,33,34,37,38,42,43,48,62] },
    { label:"Recepción y Materiales", ids:[35,39,40] },
    { label:"Procesos Productivos",   ids:[15,18,19,14,41,60] },
    { label:"Gestión y Soporte",      ids:[9,10,11,12,13,16,17,20,21,51,52] },
    { label:"Seguridad e Integridad", ids:[22,23,24,30,31,49,53,61,63] },
    { label:"Sustentabilidad",        ids:[36] },
    { label:"Inteligencia",           ids:[25] },
    ...(esAdmin ? [{ label:"Administración", ids:[26,44,45,46,47,50] }] : []),
    { label:"Finanzas", ids:[54,55,56,57,58,59] },
  ];
  const modulosVisibles = modulos.filter(m => puedeVer(usuario, m.id));
  return (
    <div style={{ minHeight:"100vh", background:bgPage, fontFamily:"Inter,sans-serif", transition:"background 0.3s" }}>
      <style>{css}</style>
      <div style={{ background:navBg, padding:"0.85rem 1.5rem", display:"flex", justifyContent:"space-between", alignItems:"center", position:"sticky", top:0, zIndex:100, boxShadow:"0 2px 20px rgba(28,63,170,0.35)" }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <AlqosLogo size={36}/>
          <div>
            <span style={{ color:"white", fontWeight:"700", fontSize:"18px", letterSpacing:".2em", fontFamily:"Montserrat,sans-serif" }}>
              ALQOS<sup style={{ fontSize:"9px", color:"rgba(255,255,255,0.6)", fontFamily:"Inter,sans-serif" }}>™</sup>
            </span>
            <span style={{ color:"rgba(255,255,255,0.38)", fontSize:"9px", display:"block", lineHeight:1, letterSpacing:".08em" }}>Sistema de Gestión Integral</span>
          </div>
        </div>
        <AlqosNewsPill onClick={() => onModulo("alqosNews")}/>
        <div style={{ display:"flex", alignItems:"center", gap:"10px" }}>
          {syncMsg && <span style={{ fontSize:"11px", color:"#86efac", background:"rgba(34,197,94,.12)", padding:"4px 10px", borderRadius:"8px", fontWeight:"600" }}>{syncMsg}</span>}
          {!online && <span style={{ fontSize:"11px", color:"#fbbf24", background:"rgba(251,191,36,.12)", padding:"4px 10px", borderRadius:"8px", fontWeight:"700" }}>📵 Sin conexión</span>}
          <button onClick={toggleOscuro} style={{ background:"rgba(255,255,255,0.08)", border:"1px solid rgba(255,255,255,0.15)", borderRadius:"20px", padding:"6px 14px", color:"white", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>
            {oscuro?"☀️":"🌙"}
          </button>
          <div style={{ display:"flex", alignItems:"center", gap:"8px" }}>
            <div style={{ width:"30px", height:"30px", borderRadius:"50%", background:`linear-gradient(135deg, ${Q.azulVivo}, ${Q.azulMedio})`, display:"flex", alignItems:"center", justifyContent:"center", color:"white", fontWeight:"700", fontSize:"12px" }}>
              {usuario.nombre[0]}
            </div>
            <div style={{ fontSize:"10px", color:"rgba(255,255,255,0.5)", lineHeight:1.4 }}>
              <div style={{ color:"white", fontWeight:"600", fontSize:"12px" }}>{usuario.nombre}</div>
              <div>{usuario.rol} · {usuario.empresa}</div>
            </div>
          </div>
          {!usuario?.esAsesorCliente && (
            <button onClick={() => onModulo("misrecibos")} style={{ background:"rgba(255,255,255,0.12)", border:"1px solid rgba(255,255,255,0.22)", color:"white", padding:"6px 14px", borderRadius:"8px", cursor:"pointer", fontSize:"12px", fontWeight:"600" }}>📄 Mis Recibos</button>
          )}
          <button onClick={onLogout} style={{ background:"rgba(255,255,255,0.06)", border:"1px solid rgba(255,255,255,0.12)", color:"rgba(255,255,255,0.65)", padding:"6px 14px", borderRadius:"8px", cursor:"pointer", fontSize:"12px" }}>Salir</button>
        </div>
      </div>
      <HomeKPIs usuario={usuario} oscuro={oscuro} onModulo={onModulo}/>
      <div style={{ padding:"0 1.5rem 6rem" }}>
        <div style={{ marginBottom:"1.8rem" }}>
          <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"10px" }}>
            <div style={{ width:"20px", height:"2px", background:"#7B5BF2", borderRadius:"2px" }}/>
            <p style={{ fontSize:"9.5px", fontWeight:"700", color:"#7B5BF2", letterSpacing:".22em", textTransform:"uppercase", margin:0 }}>Mi Espacio</p>
            <div style={{ flex:1, height:"1px", background:oscuro?"rgba(255,255,255,0.05)":"rgba(28,63,170,0.06)" }}/>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(148px, 1fr))", gap:"10px" }}>
            {!usuario?.esAsesorCliente && (
            <div onClick={() => onModulo("misrecibos")}
              style={{ background:oscuro?cardBg:"#EEF3FF", borderRadius:"14px", padding:"1rem", cursor:"pointer", border:"1.5px solid #7B5BF240", position:"relative", overflow:"hidden", transition:"transform 0.15s, box-shadow 0.15s" }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow="0 8px 24px #7B5BF220";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
              <div style={{ position:"absolute", top:0, left:0, right:0, height:"2px", background:"linear-gradient(90deg, #7B5BF2, transparent)", borderRadius:"14px 14px 0 0" }}/>
              <div style={{ width:"38px", height:"38px", borderRadius:"10px", background:"#7B5BF210", border:"1px solid #7B5BF225", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"9px", fontSize:"18px" }}>📄</div>
              <div style={{ fontSize:"12px", fontWeight:"600", color:texto, lineHeight:"1.3" }}>Mis Recibos</div>
              <div style={{ width:"16px", height:"1.5px", background:"#7B5BF2", borderRadius:"2px", marginTop:"7px", opacity:0.6 }}/>
            </div>
            )}
            {usuario?.rol === "Administrador" && Number(usuario?.tenant_id) === 1 && (
            <div onClick={() => onModulo("superadmin")}
              style={{ background:oscuro?cardBg:"#EEF3FF", borderRadius:"14px", padding:"1rem", cursor:"pointer", border:"1.5px solid #f59e0b40", position:"relative", overflow:"hidden", transition:"transform 0.15s, box-shadow 0.15s" }}
              onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow="0 8px 24px #f59e0b20";}}
              onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
              <div style={{ position:"absolute", top:0, left:0, right:0, height:"2px", background:"linear-gradient(90deg, #f59e0b, transparent)", borderRadius:"14px 14px 0 0" }}/>
              <div style={{ width:"38px", height:"38px", borderRadius:"10px", background:"#f59e0b10", border:"1px solid #f59e0b25", display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"9px", fontSize:"18px" }}>⚙️</div>
              <div style={{ fontSize:"12px", fontWeight:"600", color:texto, lineHeight:"1.3" }}>Super Admin</div>
              <div style={{ width:"16px", height:"1.5px", background:"#f59e0b", borderRadius:"2px", marginTop:"7px", opacity:0.6 }}/>
            </div>
            )}
          </div>
        </div>
        {categorias.map(cat => {
          const modulosCat = modulosVisibles.filter(m => cat.ids.includes(m.id));
          if (!modulosCat.length) return null;
          const acento = colorCat[cat.label] || Q.azulVivo;
          const esIA   = cat.label === "Inteligencia";
          return (
            <div key={cat.label} style={{ marginBottom:"1.8rem" }}>
              <div style={{ display:"flex", alignItems:"center", gap:"10px", marginBottom:"10px" }}>
                <div style={{ width:"20px", height:"2px", background:acento, borderRadius:"2px" }}/>
                <p style={{ fontSize:"9.5px", fontWeight:"700", color:acento, letterSpacing:".22em", textTransform:"uppercase", margin:0 }}>{cat.label}</p>
                <div style={{ flex:1, height:"1px", background:oscuro?"rgba(255,255,255,0.05)":"rgba(28,63,170,0.06)" }}/>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(148px, 1fr))", gap:"10px" }}>
                {modulosCat.map(m => {
                  const sigla = m.nombre.split(" ").map(w=>w[0]).join("").slice(0,3).toUpperCase();
                  const esAsesores = m.id === 49;
                  return (
                    <div key={m.id} onClick={() => onModulo(getModulo(m.id))}
                      style={{ background:(esIA||esAsesores)?`linear-gradient(135deg,${Q.azul},${Q.navOscuro})`:oscuro?cardBg:"#EEF3FF", borderRadius:"14px", padding:"1rem", cursor:"pointer", border:(esIA||esAsesores)?`1.5px solid ${Q.azulVivo}40`:`1.5px solid ${cardBorder}`, transition:"transform 0.15s, box-shadow 0.15s", position:"relative", overflow:"hidden" }}
                      onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-3px)";e.currentTarget.style.boxShadow=`0 8px 24px ${acento}20`;}}
                      onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
                      <div style={{ position:"absolute", top:0, left:0, right:0, height:"2px", background:`linear-gradient(90deg, ${acento}, transparent)`, borderRadius:"14px 14px 0 0" }}/>
                      <div style={{ width:"38px", height:"38px", borderRadius:"10px", background:esIA?"rgba(255,255,255,0.1)":oscuro?`${acento}14`:`${acento}10`, border:`1px solid ${acento}25`, display:"flex", alignItems:"center", justifyContent:"center", marginBottom:"9px" }}>
                        <span style={{ fontSize:"9px", fontWeight:"800", color:(esIA||esAsesores)?"white":acento, letterSpacing:".06em", fontFamily:"Montserrat,sans-serif" }}>{sigla}</span>
                      </div>
                      <div style={{ fontSize:"12px", fontWeight:"600", color:(esIA||esAsesores)?"white":texto, lineHeight:"1.3" }}>{m.nombre}</div>
                      <div style={{ width:"16px", height:"1.5px", background:acento, borderRadius:"2px", marginTop:"7px", opacity:0.6 }}/>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <div style={{ background:navBg, padding:"0.6rem 2rem", display:"flex", justifyContent:"center", alignItems:"center", position:"fixed", bottom:0, left:0, right:0, boxShadow:"0 -2px 20px rgba(28,63,170,0.35)", zIndex:100 }}>
        <span style={{ fontSize:"9px", color:"rgba(255,255,255,0.3)", letterSpacing:".18em", fontFamily:"Montserrat,sans-serif", fontWeight:"600" }}>
          ALQOS™ · SISTEMA DE GESTIÓN INTEGRAL · by QORVEX · CONFIDENCIAL · © 2026
        </span>
      </div>
    </div>
  );
}
// ─── PANTALLA DE SINCRONIZACIÓN INICIAL ────────────────────────
function SincronizandoScreen({ oscuro, texto = "Sincronizando datos..." }) {
  return (
    <div style={{ minHeight:"100vh", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"14px", background: oscuro ? Q.fondoOscuro : Q.grisPalido, fontFamily:"Inter,sans-serif" }}>
      <div style={{ width:"36px", height:"36px", border:`3px solid ${oscuro ? "#1e3a8a" : Q.grisClaro}`, borderTopColor: Q.azulVivo, borderRadius:"50%", animation:"rotateHex 0.9s linear infinite" }} />
      <p style={{ color: oscuro ? "#EDF2FA" : Q.grisOscuro, fontSize:"14px", fontWeight:"600", margin:0 }}>{texto}</p>
    </div>
  );
}
// ─── APP ──────────────────────────────────────────────────────
export default function App() {
  const [usuario,        setUsuario]        = useState(null);
  const [oscuro,         setOscuro]         = useState(false);
  const [moduloActivo,   setModuloActivo]   = useState(null);
  const [historial,      setHistorial]      = useState([]);
  const [ncParaAnalisis, setNcParaAnalisis] = useState(null);
  const [online,         setOnline]         = useState(navigator.onLine);
  const [modalOCFlotante, setModalOCFlotante] = useState(false);
  const [syncMsg,        setSyncMsg]        = useState("");
  const [sincronizando,  setSincronizando]  = useState(false);
  const [verificandoSesion, setVerificandoSesion] = useState(true);
  // Al montar: si ya hay una sesión de Supabase activa (ej. después de un
  // reload de la impersonación de superadmin, o simplemente al refrescar la
  // página con una sesión vigente), restaurar `usuario` sin pedir login de
  // nuevo. Sin esto, cualquier reload manda directo a <Login/> aunque el
  // token siga siendo válido, porque `usuario` solo vive en memoria.
  useEffect(() => {
    (async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (session && !usuario) {
          const resultado = await autenticarSupabaseDesdeSesion();
          if (resultado.usuario) setUsuario(resultado.usuario);
        }
      } finally {
        setVerificandoSesion(false);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    const goOnline = () => {
      setOnline(true);
      setSyncMsg("🔄 Sincronizando...");
      sincronizarTodo().then(() => { setSyncMsg("✅ Sincronizado"); setTimeout(() => setSyncMsg(""), 3000); });
    };
    const goOffline = () => { setOnline(false); setSyncMsg(""); };
    window.addEventListener("online", goOnline);
    window.addEventListener("offline", goOffline);
    return () => { window.removeEventListener("online", goOnline); window.removeEventListener("offline", goOffline); };
  }, []);
  // Timeout de sesión por inactividad (30 min), para cualquier sesión
  // logueada -- usuario de tenant o el superadmin en su propia sesión.
  // Independiente de la expiración a 24hs de la impersonación (esa vive en
  // BarraImpersonacion.js sobre alqos_impersonando/iniciado_en; esto acá es
  // un timeout general de sesión, no específico de impersonación).
  // Reemplaza al mecanismo viejo de 60 min que solo hacía setUsuario(null):
  // como App.js ahora restaura la sesión de Supabase al montar (ver el
  // useEffect de arriba), "cerrar sesión" sin llamar a signOut() dejaba el
  // token igual de válido en localStorage -- un reload volvía a loguear
  // solo. Acá sí se cierra la sesión de Supabase de verdad.
  useEffect(() => {
    if (!usuario) return;
    const LIMITE_INACTIVIDAD_MS = 30 * 60 * 1000;
    const EVENTOS_ACTIVIDAD = ["mousemove", "click", "keydown", "touchstart", "scroll"];
    let throttled = false;
    const registrarActividad = () => {
      if (throttled) return;
      throttled = true;
      setTimeout(() => { throttled = false; }, 5000);
      localStorage.setItem("alqos_last_activity", String(Date.now()));
    };
    const cerrarPorInactividad = async () => {
      try { await supabase.auth.signOut(); } catch (e) { console.error("Error cerrando sesión por inactividad:", e); }
      // Limpia también el estado de impersonación si había uno activo, para
      // no dejar el banner naranja huérfano en el próximo login de alguien
      // más en esta máquina (mismo criterio que el botón "Salir").
      localStorage.removeItem("alqos_impersonando");
      localStorage.removeItem("alqos_sesion_superadmin");
      localStorage.removeItem("alqos_last_activity");
      setUsuario(null);
      alert("Sesión cerrada por inactividad. Volvé a ingresar.");
      window.location.reload();
    };
    // El setInterval de abajo puede no correr puntual si la pestaña queda
    // en segundo plano o la máquina duerme -- por eso también se revisa el
    // tiempo real transcurrido apenas la pestaña vuelve a estar visible,
    // en vez de confiar solo en que el interval haya tickeado a tiempo.
    const chequearInactividad = () => {
      const last = parseInt(localStorage.getItem("alqos_last_activity"), 10) || Date.now();
      if (Date.now() - last > LIMITE_INACTIVIDAD_MS) cerrarPorInactividad();
    };
    const onVisibilidad = () => { if (document.visibilityState === "visible") chequearInactividad(); };
    registrarActividad();
    EVENTOS_ACTIVIDAD.forEach(ev => window.addEventListener(ev, registrarActividad, { passive: true, capture: ev === "scroll" }));
    document.addEventListener("visibilitychange", onVisibilidad);
    window.addEventListener("focus", chequearInactividad);
    const iv = setInterval(chequearInactividad, 60000);
    return () => {
      EVENTOS_ACTIVIDAD.forEach(ev => window.removeEventListener(ev, registrarActividad, { capture: ev === "scroll" }));
      document.removeEventListener("visibilitychange", onVisibilidad);
      window.removeEventListener("focus", chequearInactividad);
      clearInterval(iv);
    };
  }, [usuario]);
  // Verificar alertas cada 15 minutos mientras hay sesión activa
 useEffect(() => {
  if (!usuario) return;
  verificarAlertasOperaciones();
  verificarAlertasReposicion(); // <-- nuevo
  const iv = setInterval(() => {
    verificarAlertasOperaciones();
    verificarAlertasReposicion(); // <-- nuevo
  }, 15 * 60 * 1000);
  return () => clearInterval(iv);
}, [usuario]);
  const handleLogin = async (user) => {
    setUsuario(user);
    setSincronizando(true);
    try {
      await sincronizarTodo();
    } catch (e) {
      console.error('Error en sincronización inicial:', e);
      alert('No se pudo sincronizar con el servidor. Algunos datos pueden estar desactualizados hasta que reintentes.');
    } finally {
      setSincronizando(false);
    }
    syncUsuariosDesdeSupabase();
    syncPermisosDesdeSupabase();
    if (user.rol==="Administrador") setTimeout(() => verificarVencimientos(user.email), 2000);
    setTimeout(() => verificarAlertasOperaciones(), 3000);
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const navegarA = (modulo) => { if(!modulo) return; setHistorial(h=>[...h,moduloActivo]); setModuloActivo(modulo); };
  const volver   = () => { const ant=historial[historial.length-1]; setHistorial(h=>h.slice(0,-1)); setModuloActivo(ant); };
  useEffect(() => {
    const onNavegar = (e) => { if (e.detail?.modulo) navegarA(e.detail.modulo); };
    window.addEventListener("alqos-navegar", onNavegar);
    return () => window.removeEventListener("alqos-navegar", onNavegar);
  }, [navegarA]);
  const nombreModulo = (m) => ({
    nc:"No Conformidades",ot:"Órdenes de Trabajo",docs:"Documentos",auditorias:"Auditorías",
    caps:"Capacitaciones",proveedores:"Proveedores",clientes:"Clientes",compras:"Compras",
    hs:"Higiene y Seguridad",preprensa:"Pre Prensa",produccion:"Producción",ventas:"Ventas",
    cotizacion:"Cotización",oficina_tecnica:"Oficina Técnica",familias:"Familias y Líneas",maquinas:"Máquinas",
    rrhh:"Recursos Humanos",fmea:"FMEA",plancontrol:"Plan de Control",
    capabilidad:"Capabilidad y MSA",dashboardca:"Dashboard CA",disenoydesarrollo:"Diseño y Desarrollo",costosnocal:"Costos de No Calidad",
escritorioCalidad:"Escritorio Calidad",consultorHS:"ALQOS Asesor",mapaProcesos:"Mapa de Procesos ALQOS™",
    espectecnicas:"Especificaciones Técnicas",tpm:"TPM Mantenimiento",
    comercioexterior:"Comercio Exterior",accionescorrectivas:"Acciones Correctivas",
    fscarqueo:"FSC Arqueo",importarcsv:"Importar CSV",adminusuarios:"Gestión de Usuarios",superadmin:"Super Admin",
    ciberseguridad:"Ciberseguridad",sustentabilidad:"Sustentabilidad y MA",programaauditorias:"Programa Auditorías",assuredquality:"Assured Quality",ingresomateriales:"Ingreso de Materiales",huellacarb:"Huella de Carbono",trazabilidad:"Trazabilidad",despacho:"Despacho",instructivos:"Instructivos ALQOS™",cumplimiento:"Cumplimiento de Normas",
    legalmatrix:"LegalMatrix Engine",alqosNews:"ALQOS News",auditoriatrazabilidad:"Auditoría y Trazabilidad",
    controlpiso:"Control de Calidad de Piso",eticarse:"Ética y RSE",
  })[m] || m;
  const modulosBase = {
  };
  if (verificandoSesion) return <SincronizandoScreen oscuro={oscuro} texto="Verificando sesión..."/>;
  if (!usuario) return <IntroLampara onLogin={handleLogin}/>;
  if (sincronizando) return <SincronizandoScreen oscuro={oscuro}/>;
  if (usuario?.rol === "Empleado") return <PortalEmpleado usuario={usuario} oscuro={oscuro} onCerrarSesion={() => { setUsuario(null); localStorage.removeItem("alqos_session"); }} />;
  if (modulosBase[moduloActivo]) {
    const mb = modulosBase[moduloActivo];
    return <ModuloBase onVolver={volver} oscuro={oscuro} titulo={mb.titulo} icono={mb.icono} descripcion={mb.descripcion} proximamente={mb.proximamente}/>;
  }
  return (
    <>
      <BarraImpersonacion/>
      {moduloActivo==="nc"                 && <NoConformidades    onVolver={volver} oscuro={oscuro} usuario={usuario} onAnalisis={(nc) => { setNcParaAnalisis(nc); navegarA('analisiscausa'); }}/>}
      {moduloActivo==="ot"                 && <OrdenTrabajo        onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="docs"               && <Documentos          onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="auditorias"         && <Auditorias          onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="caps"               && <Capacitaciones      onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="proveedores"        && <Proveedores         onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="clientes"           && <Clientes            onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="compras"            && <Compras             onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="hs"                 && <HigieneSeguridad    onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="preprensa"          && <PrePrensa           onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="produccion"         && <Produccion          onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="ventas"             && <Ventas              onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="cotizacion"         && <Cotizacion          onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="oficina_tecnica"    && <OficinaTecnica      onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="familias"           && <FamiliasLineas      onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="maquinas"           && <Maquinas            onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="fmea"               && <FMEA                onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="plancontrol"        && <PlanControl         onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="controlpiso"        && <ControlCalidadPiso  onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="rrhh"               && <RecursosHumanos     onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="dashboardca"        && <DashboardCA         onVolver={volver} oscuro={oscuro} usuario={usuario} navegarA={navegarA}/> }
      {moduloActivo==="accionescorrectivas"&& <AccionesCorrectivas onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="fscarqueo"          && <FSCArqueo           onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="aria"               && <Aria                onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="importarcsv"        && <ImportadorCSV       onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="adminusuarios"      && <AdminUsuarios       onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="superadmin"          && <SuperAdmin          onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="instructivos"        && <Instructivos        onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="cumplimiento"        && <CumplimientoNormas  onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="tpm"                && <TPMMantenimiento    onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="ciberseguridad"     && <Ciberseguridad      onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="sustentabilidad"    && <Sustentabilidad     onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="eticarse" && <EticaRSE onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="capabilidad" && <Capabilidad onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="analisiscausa" && <AnalisisCausa onVolver={volver} oscuro={oscuro} usuario={usuario} ncInicial={ncParaAnalisis}/>}
      {moduloActivo==="programaauditorias" && <ProgramaAuditorias onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="assuredquality" && <AssuredQuality onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="ingresomateriales" && <IngresoMateriales onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="huellacarb" && <HuellaCarbono onVolver={volver} oscuro={oscuro} usuario={usuario}/> }
      {moduloActivo==="haccp" && <HACCP onVolver={volver} oscuro={oscuro} usuario={usuario}/> }
      {moduloActivo==="poes" && <POEs onVolver={volver} oscuro={oscuro} usuario={usuario}/> }
      {moduloActivo==="stock" && <StockMateriales onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="trazabilidad" && <Trazabilidad onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="despacho" && <Despacho onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="espectecnicas" && <EspecificacionesTecnicas onVolver={volver} oscuro={oscuro} usuario={usuario}/> }
      {moduloActivo==="disenoydesarrollo" && <DisenoDesarrollo onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="comercioexterior" && <ComercioExterior onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="costosnocal" && <CostosNoCalidad onVolver={volver} oscuro={oscuro} usuario={usuario} onNavegar={navegarA}/>}
      {moduloActivo==="escritorioCalidad" && <EscritorioCalidad onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="alqosNews" && <AlqosNews onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="consultorHS"       && <ConsultorHS        onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="legalmatrix" && <LegalMatrixEngine onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="mapaProcesos"      && <MapaProcesos      onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="centrosCosto"      && <CentrosCosto      onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="plancuentas"       && <PlanCuentas       onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="asientoscontables" && <AsientosContables onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="cxccxp"            && <CuentasCobrarPagar onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="movimientoscaja"   && <MovimientosCaja   onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="finanzas"            && <Finanzas            onVolver={volver} oscuro={oscuro} usuario={usuario} onNavegar={navegarA}/>}
      {moduloActivo==="balancesimplificado" && <BalanceSimplificado onVolver={volver} oscuro={oscuro} usuario={usuario} onNavegar={navegarA}/>}
      {moduloActivo==="motorCosteo"        && <MotorCosteo        onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="comunicados" && <Comunicados onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="onboarding" && <Onboarding onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="auditoriatrazabilidad" && <AuditoriaTrazabilidad onVolver={volver} oscuro={oscuro} usuario={usuario}/>}
      {moduloActivo==="misrecibos" && <PortalEmpleado usuario={usuario} oscuro={oscuro} onVolver={volver}/>}
      {!moduloActivo && <Menu usuario={usuario} onLogout={()=>setUsuario(null)} oscuro={oscuro} toggleOscuro={()=>setOscuro(o=>!o)} onModulo={navegarA} online={online} syncMsg={syncMsg}/>}
      {usuario && moduloActivo !== "aria" && (
        <FeedbackWidget modulo={moduloActivo?nombreModulo(moduloActivo):"Menú principal"} usuario={usuario} oscuro={oscuro}/>
      )}
      {usuario && moduloActivo !== "consultorHS" && (
        <>
          <button onClick={() => setModalOCFlotante(true)}
            style={{ position:"fixed", bottom:"28px", right:"80px", width:"52px", height:"52px", borderRadius:"50%", background:"linear-gradient(135deg,#7B5BF2,#09184D)", color:"white", border:"none", cursor:"pointer", fontSize:"22px", boxShadow:"0 4px 20px rgba(123,91,242,0.5)", zIndex:500, display:"flex", alignItems:"center", justifyContent:"center" }}
            title="Solicitar compra">
            🛒
          </button>
          {modalOCFlotante && (
            <ModalGenerarOC oscuro={oscuro} usuario={usuario} origen="Manual"
              categoriaDefault="Servicios"
              onClose={() => setModalOCFlotante(false)}
              onCreada={(cod) => { alert(`✅ OC generada: ${cod} — revisá el módulo Compras`); setModalOCFlotante(false); }}
            />
          )}
        </>
      )}
    </>
  );
}
